import React, { createContext, useContext, useState, ReactNode } from 'react';
import { PageConfig } from '../pages';

interface PageConfigContextType {
  pageConfig: PageConfig;
  setPageConfig: (config: PageConfig) => void;
}

const PageConfigContext = createContext<PageConfigContextType | undefined>(undefined);

export const PageConfigProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [pageConfig, setPageConfig] = useState<PageConfig>({ title: '', actions: [] });

  return (
    <PageConfigContext.Provider value={{ pageConfig, setPageConfig }}>
      {children}
    </PageConfigContext.Provider>
  );
};

export const usePageConfig = () => {
  const context = useContext(PageConfigContext);
  if (!context) {
    throw new Error('usePageConfig must be used within a PageConfigProvider');
  }
  return context;
};
